import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CameraButton = ({ onClick, isDarkMode }) => {
  const [isHovered, setIsHovered] = useState(false);
  const isSmallMobile = useRef(window.innerWidth < 375);
  const isMobile = useRef(window.innerWidth < 768);
  
  // Track window resize for mobile detection
  useEffect(() => {
    const handleResize = () => {
      isMobile.current = window.innerWidth < 768;
      isSmallMobile.current = window.innerWidth < 375;
    };
    
    window.addEventListener('resize', handleResize);
    handleResize(); // Call once initially
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return (
    <div className="relative">
      <motion.button
        onClick={onClick}
        onHoverStart={() => setIsHovered(true)}
        onHoverEnd={() => setIsHovered(false)}
        className="relative flex items-center justify-center"
        style={{
          width: isSmallMobile.current ? '30px' : isMobile.current ? '32px' : '36px',
          height: isSmallMobile.current ? '30px' : isMobile.current ? '32px' : '36px'
        }}
        title="Upload image"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        {/* Background circle */}
        <motion.div 
          className="absolute inset-0 rounded-full"
          style={{
            backgroundColor: isDarkMode ? 'rgba(60, 60, 60, 0.8)' : 'rgba(229, 231, 235, 0.8)'
          }}
        />

        {/* Camera icon */}
        <motion.div
          className="relative z-10"
          animate={isHovered ? {
            transition: { duration: 0.2 }
          } : {}}
        >
          <i 
            className={`fas fa-camera ${isSmallMobile.current ? 'text-xs' : 'text-sm'}`}
            style={{
              color: isDarkMode ? '#cdd1d6' : '#50565c'
            }}
          />
        </motion.div>

        {/* Button glow on hover */}
        <AnimatePresence>
          {isHovered && (
            <motion.div
              className="absolute inset-0 rounded-full"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              style={{
                boxShadow: isDarkMode 
                  ? '0 0 8px rgba(200, 200, 200, 0.3)' 
                  : '0 0 6px rgba(100, 100, 100, 0.3)'
              }}
              transition={{
                duration: 0.2
              }}
            />
          )}
        </AnimatePresence>
      </motion.button>
    </div>
  );
};

export default CameraButton; 